import { Component, signal } from '@angular/core';
import { FileUploadZoneComponent } from '../../shared/components/file-upload-zone/file-upload-zone.component';

@Component({
  selector: 'app-build-instance',
  imports: [FileUploadZoneComponent],
  templateUrl: './build-instance.component.html',
  styles: `
    .page-header__row {
      display: flex;
      align-items: center;
      gap: 0.65rem;
    }
    .steps {
      margin-bottom: 1.5rem;
    }
    .steps ol {
      margin: 0.5rem 0 1rem;
      padding-left: 1.4rem;
      display: grid;
      gap: 0.5rem;
      max-width: 60rem;
    }
    .meta {
      margin: 1rem 0 0;
      font-size: 0.9rem;
    }
    .notice {
      margin-top: 0.75rem;
    }
  `,
})
export class BuildInstanceComponent {
  protected readonly filename = signal<string | null>(null);

  protected onFile(files: File[]): void {
    if (!files.length) return;
    this.filename.set(files[0].name);
  }
}
